<template>
  <div class="brains-infohelper-container">
    <font-awesome-icon class="brains-infohelper-icon" icon="info-circle" />
    <div class="brains-infohelper-txt">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.brains-infohelper-container {
  display: flex;
  align-items: center;

  &:hover .brains-infohelper-txt {
    display: block;
  }

  .brains-infohelper-icon {
    cursor: pointer;
    color: lightgrey;
    width: 20px;
    height: 20px;

  }

  .brains-infohelper-txt {
    display: none;
    position: absolute;
    padding: 10px;
    max-width: 200px;
    text-align: left;
    background-color: white;
    font-family: 'Montserrat-Light',sans-serif;
    border: 1px solid #1e3cff;
    font-size: 13px;
    top: 45px;
    z-index: 100;
    border-radius: 5px;
    box-shadow: 0px 0px 4px 1px #1e3cff;
  }
}
</style>
